import { render, staticRenderFns } from "./eShoppingList.vue?vue&type=template&id=445079d2&scoped=true"
import script from "./eShoppingList.vue?vue&type=script&lang=js"
export * from "./eShoppingList.vue?vue&type=script&lang=js"
import style0 from "./eShoppingList.vue?vue&type=style&index=0&id=445079d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445079d2",
  null
  
)

export default component.exports